(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/actions/go-to-betting-history-callback.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/actions/go-to-betting-history-callback.js');
"use strict";


svs.sportsbook.sbtech_api_impl.fns.actions.goToBettingHistoryCallback = post => post;

 })(window);